/**
 * Determines if the user has completed the form based on available state
 *
 * A user can chat if ANY of these conditions are true:
 * - Has an existing session (returning user)
 * - Has filled the questionnaire form (new user who submitted form)
 * - Is on a proposal page (ProposalConversation mode - no form needed)
 *
 * @param sessionId - Existing session ID from localStorage
 * @param filledQuestionnaireData - Form data submitted by user
 * @param proposalId - Proposal ID from URL context (ProposalConversation mode)
 * @returns true if user can access chat, false if they need to fill the form first
 */
export const getHasCompletedForm = (
  sessionId: string | null,
  filledQuestionnaireData: Record<string, string>,
  proposalId?: string | null
): boolean => {
  return (
    !!sessionId ||
    Object.keys(filledQuestionnaireData).length > 0 ||
    !!proposalId
  );
};
